'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { FaqSection } from '../../FaqSection';
import { GetDirectionsSection } from '../../GetDirectionsSection';
import { FESTIVE_FAQ_ITEMS } from '../festiveFaqData';
import { FESTIVE_TERMS_URL } from '../festiveAssets';
import { usePerformanceLabNavOverride } from '../../performanceLabNavAppearance';
import { FestivePanelsLayout } from './FestivePanelsLayout';
import { FestiveV2Hero } from './FestiveV2Hero';
import { FestiveStickyCallback } from './FestiveStickyCallback';
import { useFestiveReveal } from './useFestiveReveal';
import styles from './festiveVersions.module.css';

/** V3 festive page (Figma 5444:4459): rising gold card, Geist plan panels. */
export const FestiveVersionPage: React.FC = () => {
  const t = useTranslations('performance-lab');
  usePerformanceLabNavOverride('flat-geist');

  const faqData = FESTIVE_FAQ_ITEMS.map((item) => ({
    title: t(item.questionKey),
    description: t(item.answerKey),
  }));

  const revealRef = useFestiveReveal<HTMLDivElement>(true);

  return (
    <div ref={revealRef} className={styles.geistPage}>
      <div className={styles.heroGrain} aria-hidden="true" />
      <FestiveV2Hero />
      <FestivePanelsLayout />
      <div className={styles.faqSurface} data-type="geist">
        <FaqSection
          faqData={faqData}
          heading={t('festive.versions.v2.faqHeading')}
          ariaLabel={t('festive.faq.aria')}
          bgColor="grey"
          disclaimer={
            <a
              href={FESTIVE_TERMS_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-buttontype="performance_lab_festive_terms"
            >
              {t('festive.faq.terms')}
            </a>
          }
        />
      </div>
      <div className={styles.directionsSurface} data-type="geist">
        <GetDirectionsSection variant="festive" />
      </div>
      <FestiveStickyCallback />
    </div>
  );
};
